// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.5 2.5H20.5V4.5H3.5V2.5ZM2.6802 5.5H21.3198L22.5 11.401V13.5H21V21.5H19V13.5H14V21.5H3V13.5H1.5V11.401L2.6802 5.5ZM5 13.5V19.5H12V13.5H5Z"}}]};

const StoreFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'store-filled',
    ref,
    icon: element,
  },
));

StoreFilledIcon.displayName = 'StoreFilledIcon';

export default StoreFilledIcon;
